import * as Cesium from "cesium";

export const getCenterFromCartesians = (positions: Cesium.Cartesian3[]) => {
	let cartographics = positions.map((position) => Cesium.Cartesian3.divideByScalar(position, positions.length, new Cesium.Cartesian3()));
	let center = Cesium.Cartographic.fromCartesian(
		cartographics.reduce((accumulator, currentValue) => Cesium.Cartesian3.add(accumulator, currentValue, new Cesium.Cartesian3()))
	);
	return center;
};
